import { AxiosResponse } from 'axios';
import { AxiosInstance } from 'axios';
import { PlansCommonResponse } from '@/repository/manager/plans/types/PlansCommonResponse';
import { IStatuses, Statuses } from '@/store/plan/Statuses/Statuses';
import { StatusesRepository } from '@/model/repository/manager/childcare-document/plan/StatusesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): StatusesRepository => ({
    getStatuses(year: string, month: string, group_id: string, use_db_replica: boolean): Promise<Statuses> {
    return new Promise<Statuses>((resolve, reject) => {
      Repository
        .get(`${resource}/year/${year}/month/${month}`, {
          params: { group_id, use_db_replica },
        })
        .then((res: AxiosResponse<PlansCommonResponse<IStatuses>>) => {
          resolve(new Statuses(res.data.data));
        })
        .catch((error) => {
          const status = error.response ? error.response.status : null;
          reject({ error, status });
        });
    });
  }
  });
